.bundle {
  &__intro {
    height: 91px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  &__container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 $space-02 $space-01;

    @include agl-ds-screen-size('large') {
      flex-direction: row;
      padding: 0 50px $space-05;
    }
  }

  &__product {
    font-size: $font-size-lg-01 !important;

    &:not(:last-child) {
      margin-bottom: $space-01;
    }

    @include agl-ds-screen-size('medium') {
      font-size: $font-size-lg-02 !important;
    }

    @include agl-ds-screen-size('large') {
      flex: 0 1 280px;
      margin-bottom: 0;
      margin-right: $space-04;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__message-tile {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    padding: 60px $space-02 0;
    text-align: center;
  }

  &__tile-heading {
    display: flex;
    flex-direction: row;

    &__left {
      flex: 0 0 $space-01;
    }

    &__middle {
      flex: 1 1 auto;
      padding-left: $space-01;
    }

    &__right {
      flex: 0 0 $space-03;
      text-align: right;
    }
  }

  &__tile-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 55px;
    text-align: left;
    padding-bottom: $space-02;
    min-height: 55px;

    @include agl-ds-screen-size('large') {
      min-height: 110px;
      text-align: left;
      padding-top: $space-01;
      padding-bottom: $space-02;
    }

    &-icon {
      flex: 0 0 $space-01;
      align-self: center;
    }
  }

  &__tile-content-no-heading {
    min-height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: $space-02;
    text-align: center;
  }

  &--desktop {
    display: none;

    @include agl-ds-screen-size('medium') {
      display: block;
    }
  }

  &--mobile {
    display: block;

    @include agl-ds-screen-size('medium') {
      display: none;
    }
  }
}
